import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=29f9070c"
import script from "./DeleteIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f9070c')) {
      api.createRecord('29f9070c', component.options)
    } else {
      api.reload('29f9070c', component.options)
    }
    module.hot.accept("./DeleteIcon.vue?vue&type=template&id=29f9070c", function () {
      api.rerender('29f9070c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/buttons/DeleteIcon.vue"
export default component.exports